import React from "react";
import Html from "./html";

const SelectDropdown = ({
  intialValue,
  creatable,
  options,
  placeholderCap = false,
  result,
  showPlaceHolder = true,
  addNewOption,
  noOptionsMessage,
  displayValue = "name",
  id,
  placeholder = "Select Status",
  disabled = false,
  name,
  required = false,
  noDefault = false,
  sort = true,
  className = "",
  theme,
  dynamicStyle = false,
  crossIcon = true,
  noCapitalize,
  showCross = true,
  isLoading = false,
  isFocusedData
}) => {
  const handleChange = (e) => {
    result({ event: "value", value: e });
  };

  return (
    <>
      <Html
        theme={theme}
        showCross={showCross}
        creatable={creatable}
        crossIcon={crossIcon}
        addNewOption={addNewOption}
        noOptionsMessage={noOptionsMessage}
        id={id}
        showPlaceHolder={showPlaceHolder}
        sort={sort}
        name={name}
        className={className}
        noDefault={noDefault}
        required={required}
        placeholderCap={placeholderCap}
        disabled={disabled}
        placeholder={placeholder}
        noCapitalize={noCapitalize}
        displayValue={displayValue}
        options={options}
        selectedValues={intialValue}
        handleChange={handleChange}
        dynamicStyle={dynamicStyle}
        isLoading={isLoading}
        isFocusedData={isFocusedData}
      />
    </>
  );
};

export default SelectDropdown;
